module.exports = __webpack_public_path__ + "img/logo_red.ad266d22.png";